
import {catchError} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExceptionService, UtilsService } from '../../../xform-compat';
import { CompanyBasic, NewCompany } from '../../../shared/models';


/**
 * Data service to handle company onboard
 */
@Injectable({
  providedIn: 'root'
})
export class AddCompanyService  {

  private url = '/api/rms/companies/onboard';

  constructor(
    private http: HttpClient,
    private exceptionService: ExceptionService
  ) {
  }

  /**
   * Creates a new Company
   * @param {NewCompany} data: form data
   * @returns {Observable<NewCompany>}: created company
   */
  public createRecord (data: NewCompany): Observable<CompanyBasic> {
    return this.http.post(this.url, data).pipe(catchError(ex => this.exceptionService.catchBadResponse(ex)));
  }

}
